import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  selectPartnerAccess,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { getActualsValueTypeExportPDFDefault } from 'partner360/helpers/sectionSettings/getActualsValueTypeExportPDFDefault'

import { getCockpitMetricOffering } from '../../lib/getCockpitMetricOffering'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/**
 * Default AVT of the plan export in the cockpit, by the same rule as Partner Completeness and the PDF
 * service. `selectCockpitDefaultMetric` is the cockpit's own metric and must not be used for the export.
 */
export const selectCockpitDefaultExportPDFMetric = createSelector(
  [selectFinancialCockpitState, selectProgramType, selectPartnerAccess],
  (state, programType, { isDistributor }) =>
    getActualsValueTypeExportPDFDefault(
      getCockpitMetricOffering(state)?.PDFActualsValueTypeDefault,
      programType === ProgramTypes.Retail,
      isDistributor
    )
)
